import i18n from "./i18n.ts";

export const formatOvertimePeriodLabel = (number: number): string =>
	i18n.t("common.overtimeNumber", {
		ns: "ui",
		number,
		defaultValue: "Overtime {{number}}",
	});

export const formatOvertimeSummary = (count: number | undefined): string => {
	if (count === undefined || count <= 0) {
		return "";
	}

	return count === 1
		? i18n.t("common.overtime", {
				ns: "ui",
				defaultValue: "Overtime",
			})
		: i18n.t("common.multipleOvertimes", {
				count,
				ns: "ui",
				defaultValue: "{{count}} overtimes",
			});
};

// Live-game state intentionally keeps compact machine values such as "OT" and
// "2OT". Convert them only at the final display boundary so persisted game
// data and simulation logic remain unchanged.
export const expandOvertimeAbbreviation = (label: string | undefined): string => {
	if (!label) {
		return "";
	}

	const match = label.match(/^(?:(\d+)OT|OT(\d+)?)$/);
	if (!match) {
		return label;
	}

	const number = Number(match[1] ?? match[2] ?? 1);
	return formatOvertimePeriodLabel(number);
};
